export default "__VITE_ASSET__BrEW$m96__"